import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import withState from 'recompose/withState';
import lifecycle from 'recompose/lifecycle';
import { connect } from 'react-redux';

import Coachs from './Coachs';
import * as activityApi from '../../http-client/endpoints/activityApi';
import * as coachApi from '../../http-client/endpoints/coachApi';
import * as fileApi from '../../http-client/endpoints/fileApi';

const getFileUrl = ({ clientToken, getFile }) => id =>
  getFile(clientToken, id).then(file => {
    if (file) {
      const arrayBufferView = new Uint8Array(file.content);
      const blob = new Blob([arrayBufferView], { type: file.type });
      const url = URL.createObjectURL(blob);
      return url;
    }
    return null;
  });

const onItemClick = ({ setCurrentCoach, setActiveTab, setIsPanelOpen, getFileUrl: getFile }) => coach => async () => {
  let photo = null;
  let degrees = [];

  if (coach && coach.photoMedia && coach.photoMedia.length > 0) {
    const [first] = coach.photoMedia;
    photo = await getFile(first.fileId);
  }

  if (coach && coach.qualificationMedia && coach.qualificationMedia.length > 0) {
    const certificates = await Promise.all(coach.qualificationMedia.map(({ fileId }) => getFile(fileId)));
    degrees = coach.qualificationMedia.map(({ name, fileId }, index) => ({
      name,
      fileId,
      file: certificates[index]
    }));
  }
  setActiveTab('activities');
  setCurrentCoach({
    ...coach,
    photo,
    degrees
  });
  setIsPanelOpen(true);
};

const onClosePanel = ({ setIsPanelOpen }) => () => {
  setIsPanelOpen(false);
};

function componentWillMount() {
  const { getActivityGroupList, getActivityList, getCoachList, params: { clientToken, clubId } } = this.props;
  getActivityGroupList(clientToken, clubId);
  getActivityList(clientToken, clubId);
  getCoachList(clientToken, clubId);
}

const onChangeTab = ({ setActiveTab }) => tab => () => {
  setActiveTab(tab);
};

export default compose(
  connect(null, { ...activityApi, ...fileApi, ...coachApi }),
  withState('isPanelOpen', 'setIsPanelOpen', false),
  withState('activeTab', 'setActiveTab', 'activities'),
  withState('currentCoach', 'setCurrentCoach', undefined),
  withHandlers({ getFileUrl }),
  withHandlers({
    onItemClick,
    onClosePanel,
    onChangeTab
  }),
  lifecycle({ componentWillMount })
)(Coachs);



// WEBPACK FOOTER //
// ./src/components/Coachs/CoachsContainer.js